import React from 'react';
import { useDispatch } from 'react-redux';

import { HEIGHT_ONE_PERCENT, MARKER_PERCENTAGE_PADDING_TOP, MARKER_PERCENTAGE_SIZE, STROKE_PARAM } from '../const';
import { ComponentsDispatch } from '../store';
import { setterGantDraggable } from '../store/slices/gantDraggableSlice';
import { setterGantItems } from '../store/slices/gantItemsSlice';
import { ItemType } from '../types';

interface IGantItemMarkerPercentage {
    item: ItemType;
    x: number;
}

const GantItemMarkerPercentage: React.FC<IGantItemMarkerPercentage> = ({ item, x }) => {
    const dispatch = useDispatch<ComponentsDispatch>();

    const size = MARKER_PERCENTAGE_SIZE;
    const y = HEIGHT_ONE_PERCENT * MARKER_PERCENTAGE_PADDING_TOP;

    const outlinePath = `M${x}, ${y}
                       L${x + size},${y + size}
                       L${x + size},${y + size + 2}
                       L${x - size},${y + size + 2}
                       L${x - size},${y + size}
                       Z`;

    const handleChangePercentage = () => {
        dispatch(setterGantDraggable({ dragging: 'percentage' }));
        dispatch(setterGantItems({ isItemEdit: false, currentGantItem: item }));
    };

    const commonProps = {
        onMouseDown: handleChangePercentage,
        cursor: 'ew-resize',
    };

    return (
        <g>
            <path d={outlinePath} fill="white" {...STROKE_PARAM} stroke={'#aaa'} strokeWidth={1} {...commonProps} />
            <line x1={x} y1={y + 2} x2={x} y2={y + 7} stroke={'#ddd'} strokeWidth={2} {...commonProps} />
        </g>
    );
};

export default React.memo(GantItemMarkerPercentage);
